import React from 'react';
import { useNavigate } from 'react-router-dom';
import StudyCompleteModalTemplate from '@component/iyagigo/modal/content-modal/study-complete-modal/study-complete-modal-template';
import TextBlock from '@component/common/block/text-block';
import { useTypedDispatch } from '@hook/common/useStore';
import { actions as modalActions } from '@store/slice/modal-slice';
import { actions as navigationActions } from '@store/slice/navigation-slice';
import { createClipPath } from '@constant/iyagigo/route-path';
import * as color from '@constant/color';

const MiniStoryCompleteModal: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();

  const handleReturnClick = () => {
    dispatch(modalActions.hideModal());
    dispatch(navigationActions.storeIyagigoSubMenu({ mainMenu: 'clip', subMenu: 'mini-story' }));
    navigate(createClipPath('home'));
  };

  return (
    <StudyCompleteModalTemplate
      title='간편이야기 학습 완료'
      result={
        <TextBlock
          text='오늘의 이야기를 모두 읽었어요'
          design={{ text: { size: 'small', color: color.GRAY_1 }, box: { alignX: 'center' } }}
        />
      }
      completedStepKey='isMiniStoryCheck'
      serviceRoute={{ title: '간편이야기로 돌아가기', handleClick: handleReturnClick }}
    />
  );
};

export default MiniStoryCompleteModal;
